"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const currency_types_1 = require("./currency_types");
class CurrencyType {
    static get default() {
        return new currency_types_1.NetworkTokens();
    }
    static get networkToken() {
        return new currency_types_1.NetworkTokens();
    }
    static get dataCredit() {
        return new currency_types_1.DataCredits();
    }
    static get security() {
        return new currency_types_1.SecurityTokens();
    }
    static get usd() {
        return new currency_types_1.USDollars();
    }
}
exports.default = CurrencyType;
//# sourceMappingURL=CurrencyType.js.map